import * as Features from '../../../../../../../shared/Features';
import * as PhotoStatus from '../../../../../../../shared/PhotoStatus';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { Category, IOrderRow } from '../../../Entities';
import { ImageEditorPhotoStatus } from '../../entry/queries/use-query-photo-status';
import { countImages } from '../../entry/state/utils';

type CanMarkDoneEditingArgs = {
    user: AuthenticatedUser;
    photoStatus: ImageEditorPhotoStatus;
    editedOrderRows: IOrderRow[];
};

function hasUploadedAllNormalImages(
    photoStatus: ImageEditorPhotoStatus,
    editedOrderRows: IOrderRow[]
): boolean {
    let requiresManualNormalImages =
        photoStatus.normalImageSizeSettings != null &&
        photoStatus.normalImageSizeSettings.autoScale === false;

    if (!requiresManualNormalImages) {
        return true;
    }

    return editedOrderRows.every((orderRow) =>
        orderRow.thumbnails
            .filter((thumbnail) => thumbnail.categoryId !== Category.EJLEV)
            .every((thumbnail) => thumbnail.hasUploadedNormal === true)
    );
}

function isInEditingStatus(photoStatus: ImageEditorPhotoStatus, editedOrderRows: IOrderRow[]) {
    return (
        photoStatus.currentStatus === PhotoStatus.EditorUploading ||
        (photoStatus.currentStatus === PhotoStatus.UploaderApproved &&
            countImages(editedOrderRows) > 0)
    );
}

function hasDoneEditingPermission(user: AuthenticatedUser, photoStatus: ImageEditorPhotoStatus) {
    return (
        Features.hasFeature(Features.DoneEditingImages, user) ||
        (Features.hasFeature(Features.HandleEditedImagesWhenPhotographerIsEditor, user) &&
            photoStatus.photographerIsEditor)
    );
}

export function canMarkDoneEditing({
    user,
    photoStatus,
    editedOrderRows
}: CanMarkDoneEditingArgs): boolean {
    return (
        hasUploadedAllNormalImages(photoStatus, editedOrderRows) &&
        isInEditingStatus(photoStatus, editedOrderRows) &&
        hasDoneEditingPermission(user, photoStatus)
    );
}
